import { useQuery } from '@tanstack/react-query';
import {
  ListEntitySuggestionsResponseSchema,
  type ListEntitySuggestionsResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { entitySuggestionKeys } from '../query-keys';

export function useEntitySuggestionsForApprover() {
  return useQuery({
    queryKey: entitySuggestionKeys.approverList(),
    queryFn: async () => {
      const { data } = await apiClient.get<ListEntitySuggestionsResponse>(
        '/api/v2/entity-suggestion?forApprover=me'
      );
      return ListEntitySuggestionsResponseSchema.parse(data).data;
    }
  });
}
